import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import {
  getVat,
  getVatbyId,
  postVat,
  editVat,
  editVatState,
  deleteVat,
  bulkVatDelete,
  exportrateVat,
  getVatTemplate,
  importVat,
  getGpa,
  getGpabyId,
  postGpa,
  editGpa,
  editGpaState,
  deleteGpa,
  bulkGpaDelete,
  exportrateGpa,
  getGpaTemplate,
  importGpa,
  getPlatformFee,
  getPlatformbyId,
  postPlatform,
  editPlatform,
  editPlatformState,
  deletePlatform,
  bulkPlatformDelete,
  exportratePlatform,
  getPlatformTemplate,
  importPlatform,
  getPlatformList,
  getRebate,
  getRebatebyId,
  postRebate,
  editRebate,
  editRebateState,
  deleteRebate,
  bulkRebateDelete,
  exportrateRebate,
  getRebateTemplate,
  importRebate,
  getRebateMode
} from '../../services/Rates/Rate_services';
const initialValues = {
  platformListData: [],
  rebateListData: []
};
let ratesStore = (set) => ({
  ...initialValues,
  getVat: async (params) => {
    const response = await getVat(params);
    return response;
  },
  getVatbyId: async (params) => {
    const response = await getVatbyId(params);
    return response;
  },
  postVat: async (params) => {
    const response = await postVat(params);
    return response;
  },
  editVat: async (params, data) => {
    const response = await editVat(params, data);
    return response;
  },
  editVatState: async (params, data) => {
    const response = await editVatState(params, data);
    return response;
  },
  deleteVat: async (params) => {
    const response = await deleteVat(params);
    return response;
  },
  bulkVatDelete: async (data) => {
    const response = await bulkVatDelete(data);
    return response;
  },
  exportrateVat: async (params) => {
    const response = await exportrateVat(params);
    return response;
  },
  getVatTemplate: async () => {
    const response = await getVatTemplate();
    return response;
  },
  importVat: async (params) => {
    const response = await importVat(params);
    return response;
  },
  getGpa: async (params) => {
    const response = await getGpa(params);
    return response;
  },
  getGpabyId: async (params) => {
    const response = await getGpabyId(params);
    return response;
  },
  postGpa: async (params) => {
    const response = await postGpa(params);
    return response;
  },
  getPlatformList: async () => {
    const response = await getPlatformList();
    set({ platformListData: response });
    return response;
  },
  editGpa: async (params, data) => {
    const response = await editGpa(params, data);
    return response;
  },
  editGpaState: async (params, data) => {
    const response = await editGpaState(params, data);
    return response;
  },
  bulkGpaDelete: async (data) => {
    const response = await bulkGpaDelete(data);
    return response;
  },
  deleteGpa: async (params) => {
    const response = await deleteGpa(params);
    return response;
  },
  exportrateGpa: async (params) => {
    const response = await exportrateGpa(params);
    return response;
  },
  getGpaTemplate: async (params) => {
    const response = await getGpaTemplate(params);
    return response;
  },
  importGpa: async (params) => {
    const response = await importGpa(params);
    return response;
  },
  getPlatformFee: async (params) => {
    const response = await getPlatformFee(params);
    return response;
  },
  getPlatformbyId: async (params) => {
    const response = await getPlatformbyId(params);
    return response;
  },
  postPlatform: async (params) => {
    const response = await postPlatform(params);
    return response;
  },
  editPlatform: async (params, data) => {
    const response = await editPlatform(params, data);
    return response;
  },
  deletePlatform: async (params) => {
    const response = await deletePlatform(params);
    return response;
  },
  bulkPlatformDelete: async (params) => {
    const response = await bulkPlatformDelete(params);
    return response;
  },
  exportratePlatform: async (params) => {
    const response = await exportratePlatform(params);
    return response;
  },
  editPlatformState: async (params, data) => {
    const response = await editPlatformState(params, data);
    return response;
  },
  getPlatformTemplate: async (params) => {
    const response = await getPlatformTemplate(params);
    return response;
  },
  importPlatform: async (params) => {
    const response = await importPlatform(params);
    return response;
  },
  getRebate: async (params) => {
    const response = await getRebate(params);
    return response;
  },
  getRebatebyId: async (params) => {
    const response = await getRebatebyId(params);
    return response;
  },
  postRebate: async (params) => {
    const response = await postRebate(params);
    return response;
  },
  editRebate: async (params,data) => {
    const response = await editRebate(params,data);
    return response;
  },
  editRebateState: async (params,data) => {
    const response = await editRebateState(params,data);
    return response;
  },
  deleteRebate: async (params) => {
    const response = await deleteRebate(params);
    return response;
  },
  bulkRebateDelete: async (params) => {
    const response = await bulkRebateDelete(params);
    return response;
  },
  exportrateRebate: async (params) => {
    const response = await exportrateRebate(params);
    return response;
  },
  getRebateTemplate: async () => {
    const response = await getRebateTemplate();
    return response;
  },
  importRebate: async (data) => {
    const response = await importRebate(data);
    return response;
  },
   getRebateMode: async () => {
    const response = await getRebateMode();
    set({ rebateListData: response });
    return response;
  },
});

ratesStore = devtools(ratesStore);

export const useRatesStore = create(ratesStore);

